import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";

const TerminosyCondiciones = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage } = useSelector(state => state.auth);

  const dispatch = useDispatch();

  /*cambiar el dispath*/

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }

  }, [successMessage, errorMessage, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          {/* Encabezado */}
          <div className="px-8 py-8">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Términos y condiciones</h2>
            </div>

            {/* Sección Comentarios */}
            <div className="mb-8 bg-gray-100 p-4 rounded-lg">
              <p className="font-semibold">
                INVERSIONES KLMA EIRL (en adelante, "LA EMPRESA"), identificada con registro único de contribuyente N° 20602845941, establece los siguientes términos y condiciones, (en adelante, los
                "TÉRMINOS Y CONDICIONES"), a fin de regular las reglas de conducta que usted (en adelante, el "EL CLIENTE"), deberá seguir al momento de realizar las transacciones que se efectúen a
                través del sitio web denominado www.tekos.pe (en adelante, "EL SITIO WEB").
              </p>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4">I. Consideraciones preliminares</h2>
              <ol className="list-decimal pl-5 space-y-4">
                <li>
                  <p>LA EMPRESA declara que toda transacción realizada en EL SITIO WEB está sujeta a los presentes TÉRMINOS Y CONDICIONES, así como a la legislación peruana vigente.</p>
                </li>
                <li>
                  <p>La aceptación de una compra en EL SITIO WEB implica la aceptación de estos TÉRMINOS Y CONDICIONES por parte de EL CLIENTE.</p>
                </li>
                <li>
                  <p>EL CLIENTE que no se encuentre de acuerdo con los términos aquí mencionados deberá abstenerse de realizar una compra en EL SITIO WEB.</p>
                </li>
              </ol>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4">II. De los términos y condiciones</h2>
              <ol className="list-decimal pl-5 space-y-4">
                <li>
                  <p>LA EMPRESA podrá modificar los presentes TÉRMINOS Y CONDICIONES de EL SITIO WEB en cualquier momento.</p>
                </li>
                <li>
                  <p>Los medios de pago que se pueden utilizar para compras en el EL SITIO WEB son:</p>
                  <ul className="list-disc pl-5 mt-2">
                    <li>Tarjetas de crédito o débito VISA, MASTERCARD, AMERICAN EXPRESS y DINERS de cualquier entidad bancaria.</li>
                    <li>PagoEfectivo, es un medio que permite pagar a través de agentes, agencias y banca por internet autorizados.</li>
                  </ul>
                </li>
                <li>
                  <p>
                    Los aspectos relativos al funcionamiento de las tarjetas de crédito o débito aceptadas en el EL SITIO WEB, están sujetos al contrato existente entre EL CLIENTE y el banco emisor de
                    su tarjeta de crédito o débito, sin que LA EMPRESA tenga responsabilidad alguna sobre los aspectos señalados en dichos contratos.
                  </p>
                </li>
                <li>
                  <p>
                    Los precios de los productos exhibidos en EL SITIO WEB son exclusivos para las compras efectuadas en tal sitio y no son aplicables a transacciones efectuadas en otras tiendas de la
                    marca TEKOS de titularidad de LA EMPRESA. Asimismo, los precios y servicios exhibidos en otras tiendas de LA EMPRESA no tienen aplicación a las transacciones efectuadas en EL SITIO
                    WEB, salvo esto sea expresamente indicado en EL SITIO WEB.
                  </p>
                </li>
                <li>
                  <p>Los precios de los productos consignados en EL SITIO WEB están expresados en moneda nacional: Soles (S/). Todo comprobante de pago se emitirá en dicha moneda.</p>
                </li>
                <li>
                  <p>Las compras realizadas en EL SITIO WEB están sujetas a disponibilidad de stock de los productos ofertados.</p>
                </li>
                <li>
                  <p>
                    Toda condición para el cambio o devolución de los productos se regirán según lo dispuesto en las POLÍTICAS DE CAMBIO Y DEVOLUCIONES quedando EL CLIENTE obligado a dar lectura de
                    tal documento.
                  </p>
                </li>
                <li>
                  <p>EL CLIENTE declara haber leído y aceptado los TÉRMINOS Y CONDICIONES, encontrándose plenamente de acuerdo y conforme con ellos.</p>
                </li>
                <li>
                  <p>
                    LA EMPRESA se reserva el derecho de solicitar documentos y/o datos adicionales a efectos de corroborar los datos personales y de envío, así como de suspender temporal o
                    definitivamente a EL CLIENTE cuyos datos no hayan podido ser confirmados.
                  </p>
                </li>
                <li>
                  <p>En ningún caso LA EMPRESA responderá por la utilización indebida que EL CLIENTE pudiera hacer de EL SITIO WEB o de los productos adquiridos.</p>
                </li>
                <li>
                  <p>
                    LA EMPRESA deja constancia y se compromete a tomar todas las medidas de seguridad tendientes a asegurar la confidencialidad y la privacidad de todas las transacciones llevadas a
                    cabo en EL SITIO WEB. Sin embargo, EL CLIENTE reconoce que EL SITIO WEB no es infalible, y que, por lo tanto, EL SITIO WEB podría verse afectado por eventos relacionados a casos
                    fortuitos o de fuerza mayor y/o intrusiones de terceros en la medida en que las medidas y contramedidas informáticas progresen. En estos casos, LA EMPRESA sin embargo, procurará
                    restablecer EL SITIO WEB con la mayor celeridad posible, sin que por ello pueda imputársele algún tipo de responsabilidad.
                  </p>
                </li>
              </ol>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4">III. Despacho de pedidos</h2>
              <ol className="list-decimal pl-5 space-y-4">
                <li>
                  <p>
                    Luego de que la compra se haya procesado el cliente recibirá un correo electrónico de confirmación con los detalles de entrega, esto dependerá del método de pago seleccionado y la
                    disponibilidad de stock de los productos ofertados (ver inciso 2.6).
                  </p>
                </li>
                <li>
                  <p>
                    En caso el titular de la compra haya solicitado la entrega de su pedido en nuestras tiendas, deberá presentar su DNI para el recojo correspondiente de su pedido. En caso el titular
                    de la compra, no pueda recoger su pedido, podrá enviar a una tercera persona, quien deberá presentar su DNI, así como la copia del DNI del titular de la compra, caso contrario no
                    podrá ser entregado el pedido.
                  </p>
                </li>
                <li>
                  <p>
                    La preparación del pedido se realiza en el periodo de un (1) día hábil. Luego de ello, los productos adquiridos se sujetarán a las condiciones de despacho y entrega disponibles que
                    se detallan a continuación:
                  </p>
                  <div className="ml-4 mt-2">
                    <p className="font-semibold">Para compras con despacho a domicilio:</p>
                    <ul className="list-disc pl-5">
                      <li>Lima metropolitana 2 a 3 días hábiles.</li>
                      <li>Provincias: 5 a 7 días hábiles.</li>
                      <li>Horario: Lunes a Viernes (9:00 a 19:00)</li>
                    </ul>
                    <p className="font-semibold mt-2">Para compras con recojo en tienda:</p>
                    <ul className="list-disc pl-5">
                      <li>Listo en hasta 2 días hábiles previa coordinación con el cliente.</li>
                    </ul>
                  </div>
                </li>
                <li>
                  <p>El pedido llegará al domicilio indicado por el Usuario dentro del horario de entrega acordado previa coordinación.</p>
                </li>
                <li>
                  <p>De no lograrse la entrega del pedido en la primera visita, este será retornado a la oficina principal de la empresa, y el costo de retorno será asumido por el cliente.</p>
                </li>
                <li>
                  <p>No se realizan repartos los domingo o feriados.</p>
                </li>
                <li>
                  <p>Excepcionalmente, podrán verificarse situaciones por las que el pedido no llegue dentro de los periodos indicados previamente, como:</p>
                  <ul className="list-disc pl-5 mt-2">
                    <li>inconvenientes en el abastecimiento y despacho del pedido</li>
                    <li>inconvenientes en el transporte del pedido por parte del operador logístico o por causas de fuerza mayor (huelgas, problemas climáticos, etc.)</li>
                    <li>que el Usuario haya consignado una dirección errada o que, siendo la correcta, no haya quien pueda recibir el pedido.</li>
                  </ul>
                  <p className="mt-2">En estos casos y se informará oportunamente al cliente el motivo de la demora y la posible solución.</p>
                </li>
              </ol>
            </div>

            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <p className="font-semibold">Para cualquier duda o consulta adicional, los usuarios podrán comunicarse a los siguientes correos atenciónalcliente@tekos.pe y teléfono +51 960 946 933</p>
            </div>

            {/* Espaciadores */}
            <div className="mb-4">
              <h2 className="text-2xl font-bold mb-4">&nbsp;</h2>
              <p className="text-justify leading-normal text-sm">&nbsp;</p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TerminosyCondiciones;
